<template>
  <v-card class="pa-6">
    <FormUnidadesConsumidoras
      ref="mainModal"
      :labelBtn="labelBtn"
      :dialog.sync="dialog"
      :selectedItem="selectedPortal"
    />
    <BaseDataTable
      :headers="headerTable"
      :items="itens"
      :loading="loading"
      :items-per-page="8"
      :paginate="true"
      :lastPage="lastPage"
      :currentPage="currentPage"
      @pageChange="fetchUnidadesConsumidoras({ ...filter, page: $event })"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="pa-0 d-flex align-center">
          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              v-can:permission="'unidades-consumidoras#store'"
              @click="openModal()"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <MenuFilterSearchTable
              :placeholder="'Buscar por Unidade Consumidora'"
              :textQuery="'unidadeConsumidora'"
              :codQuery="'uc'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>
      <!-- ---------------- header ---------------- -->
      <template v-slot:header.uc="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.cnpj="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :upperCase="false"
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <!-- ---------------- items ---------------- -->
      <template v-slot:item.uc="{ item }">
        {{ item.uc }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip v-can:permission="'unidades-consumidoras#delete'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="deletePortal(item)">
              <v-icon size="20" :attrs="attrs" v-on="on" color="error"
                >mdi-trash-can</v-icon
              >
            </v-btn>
          </template>
          Apagar portal
        </v-tooltip>
      </template>
    </BaseDataTable>
  </v-card>
</template>
<script>
import toast from "@/commom/toast.js";
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import unidadesConsumidoras from "@/services/http/rpa/UnidadesConsumidoras.js";
import { permissions } from "@/store/permissionsStore";
import FormUnidadesConsumidoras from "./FormUnidadesConsumidoras.vue";

export default {
  components: {
    FormUnidadesConsumidoras,
    MenuFilter,
    BaseDataTable,
    MenuFilterSearchTable,
  },
  data() {
    return {
      portal: {},
      loading: false,
      labelBtn: "",
      dialog: false,
      selectedPortal: "",
      lastPage: 1,
      currentPage: 1,
      itens: [],
      filter: {},
    };
  },

  watch: {
    filter(value) {
      this.fetchUnidadesConsumidoras(value);
    },
  },

  computed: {
    tableFilter() {
      return this.tmpTable.filter(
        (item) =>
          item.cnpj.includes(this.cnpj) &&
          item.uc.includes(this.description)
      );
    },

    headerTable() {
      const permissionUser = permissions();
      let headers = [
        {
          text: "Apelido",
          align: "left",
          sortable: true,
          value: "apelido",
          filterable: true,
        },
        {
          text: "CNPJ",
          align: "center",
          value: "cnpj",
          filterable: true,
        },
        {
          text: "Unidade Consumidora",
          align: "center",
          sortable: true,
          value: "uc",
          filterable: true,
        }
      ];

      if (
        permissionUser.getPermissions["unidades-consumidoras"].includes(
          "delete",
        )
      ) {
        headers.push({ text: "Ações", align: "center", value: "action" });
      }
      return headers;
    },
  },

  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    openModal() {
      this.dialog = true;
      this.labelBtn = "Cadastrar";
      if (this.$refs.mainModal.$refs.formGroups)
        this.$refs.mainModal.$refs.formGroups.reset();
    },

    openModalAdd(item) {
      this.dialogContrib = true;
      this.nameGroup = item.nome;
      this.selectedPortal = item;
    },

    async closeModal() {
      this.dialog = false;
      await this.fetchUnidadesConsumidoras(this.filter);
    },

    async fetchUnidadesConsumidoras(filters) {
      try {
        this.loading = true;
        let { data } = await unidadesConsumidoras().viewShow({ ...filters, per_page: 8 });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.itens = data.data;

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deletePortal(item) {
      let res = await this.$swal({
        title: "Você tem certeza?",
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar unidade consumidora",
        cancelButtonText: "Cancelar",
      });
      if (!res.isConfirmed) return;
      try {
        await unidadesConsumidoras(item.uc).delete();
        toast("success", "Unidade Consumidora removida");
      } catch (err) {
        toast("error", "Erro inesperado");
      } finally {
        this.fetchUnidadesConsumidoras(this.filter);
      }
    },
  },
  async created() {
    await this.fetchUnidadesConsumidoras();
  },
};
</script>
<style>
@import "../../../../assets/style/style.css";
</style>